import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const ComplaintReducer = createSlice({
  name: "Complaint",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("ComplaintReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = ComplaintReducer;
export const { defaultAction } = actions;
export default reducer;
